export enum ProfileViewDataEnum {
  is_view_card_add = 'is_view_card_add',
  is_view_todo = 'is_view_todo',
  is_view_events = 'is_view_events',
  is_view_garage = 'is_view_garage',
  is_view_hubs = 'is_view_hubs',
  is_view_invites = 'is_view_invites',
  is_view_journal = 'is_view_journal',
  is_view_tasks = 'is_view_tasks',
  is_view_archive = 'is_view_archive',
  is_view_backlog = 'is_view_backlog',
  is_view_calendar = 'is_view_calendar',
  is_view_valentine2023 = 'is_view_valentine2023',
  is_view_onboarding = 'is_view_onboarding',
}
